import { Vec2 } from "lib/math";

type GetDistance = (x: number, y: number) => number;

type RayMarchStep = {
  position: Vec2;
  radius: number;
};

function clamp(x: number, min: number, max: number) {
  return Math.min(Math.max(x, min), max);
}

export function rayMarchPositions(
  samplePt: Vec2,
  lightPosition: Vec2,
  getDistance: GetDistance
): RayMarchStep[] {
  const rayOrigin = samplePt;
  const rayDirection = lightPosition.minus(samplePt).normalized();
  const stopAt: number = samplePt.minus(lightPosition).length();
  let steps: RayMarchStep[] = [];

  let rayProgress = 0;
  for (let i = 0; i < 64; i++) {
    const pointAlongRay = rayOrigin.plus(rayDirection.times(rayProgress));

    const sceneDist = getDistance(
      clamp(pointAlongRay.x, 1, window.innerWidth - 1),
      clamp(pointAlongRay.y, 1, window.innerHeight - 1)
    );
    if (rayProgress > stopAt) {
      break;
    }

    steps.push({
      position: pointAlongRay,
      radius: Math.max(sceneDist, 0),
    });

    if (sceneDist < 0) {
      return steps;
    }

    rayProgress += sceneDist;
  }

  return steps;
}
